<template>
  <SideBar class="pl-1 pr-1" :buttons="true">
    <template #content>
      <TText value="Calendar" font_weight="500" style="margin-bottom: 4px;"/>

      <v-divider color="grey"/>

      <!-- TAKTTIME, FIRST DAY OF WEEK, TAKT START -->
      <div class="calendar-side-bar-headline-container">
        <TText value="Takttime" font_weight="400" />
        <DropDownModular
          :selected="project.takt_time_value"
          :options="takt_time_options"
          padding="0 16px"
          justify_content="center"
          z_index="1"
          @updateSelected="setTaktTime({
            id: project_id,
            takt_time_value: $event,
            })"
        >
          <template #head>
            <div class="calendar-side-bar-top-attributes-drop-down" v-ripple>
              <TText :text="project.takt_time_value" font_weight="400" />
              <TIcon name="chevron-down" small />
            </div>
          </template>
        </DropDownModular>
      </div>

      <div class="calendar-side-bar-headline-container">
        <TText value="First Day of Week" font_weight="400" />
        <DropDownModular
          :selected="getFirstDayOfWeek(project_id)"
          :options="week_days_options"
          padding="0 16px"
          justify_content="center"
          z_index="1"
          @updateSelected="setFirstDayOfWeek({
            id: project_id,
            first_day_of_week: $event
            })"
        >
          <template #head>
            <div class="calendar-side-bar-top-attributes-drop-down" v-ripple>
              <TText :text="getFirstDayOfWeek(project_id)" font_weight="400" />
              <TIcon name="chevron-down" small />
            </div>
          </template>
        </DropDownModular>
      </div>

      <div class="calendar-side-bar-headline-container">
        <TText value="Takt Start" font_weight="400" />
      </div>
      <StandardButtonSelectorHorizontal
        class="mt-1 mb-2"
        :options="getRegularWeek(project_id)"
        @input="setTaktStart({id: project_id, takt_start: $event})"
      />

      <v-divider class="mb-1" color="grey" />

      <!-- WORKING TIME -->
      <div class="calendar-side-bar-headline-container">
        <TText value="Working_Time" font_weight="400" />
      </div>

      <StandardTimePicker
        @change="updateUObject({
            url: [
              { projects: project_id}
            ],
            update: {
              working_time_start: $event.start,
              working_time_duration: $event.duration
            },
          })"
        :time_range="{
            start: $store.state.Ultra.projects[project_id].working_time_start,
            duration: $store.state.Ultra.projects[project_id].working_time_duration,
          }"
      />

      <!-- grid: Zeilen (Add-Button und Gridsection) evtl gleich hoch? -->
      <CollapsableCategory value="Grid">
        <template #content="{ is_collapsed, }">
          <div v-if="!is_collapsed" class="calendar-side-bar-sections-container">
            <!-- UPPER LIMIT -->
            <TTimePicker
              :value="$store.state.Ultra.projects[project_id].working_time_start"
              :is_disabled="true"
            />

            <!-- ADD ABOVE ALL TIMES -->
            <TIconButton
              v-if="showAddSection($store.state.Ultra.projects[project_id].working_time_start, -1)"
              icon="sign-plus"
              tooltip="Add section"
              @clickIcon="addSection($store.state.Ultra.projects[project_id].working_time_start, -1)"
            />

            <!-- SECTIONS -->
            <div
              v-for="(section, index) in getGridSections(project_id)"
              :key="section.id"
              class="calendar-side-bar-sections-container"
            >
              <div class="calendar-side-bar-sections-element">
                <!-- SECTION TIMESPAN PICKER -->
                <StandardTimePicker
                  :time_range="section"
                  :limit_time_range="getLimit(index)"
                  @change="updateUObject({
                    url: [
                      {projects: project_id},
                      {gridsections: section.id}
                    ],
                    update: { start: $event.start, duration: $event.duration}
                  })"
                />
                <!-- DELETE SECTION -->
                <TIconButton
                  icon="bin"
                  tooltip="Delete section"
                  @clickIcon="deleteUObject({
                      url: [
                        {projects: project_id},
                        {gridsections: section.id}
                      ]
                    })"
                />
              </div>

              <!-- ADD UNDERNEATH A SECTION -->
              <TIconButton
                v-if="showAddSection(section.start + section.duration, index)"
                icon="sign-plus"
                tooltip="Add section"
                @clickIcon="addSection(section.start + section.duration, index)"
              />
            </div>

            <!-- LOWER LIMIT -->
            <TTimePicker
              :value="$store.state.Ultra.projects[project_id].working_time_start + $store.state.Ultra.projects[project_id].working_time_duration"
              :is_disabled="true"
            />
          </div>
        </template>
      </CollapsableCategory>

      <v-divider class="mb-1" color="grey"/>

      <!-- PROJECT START -->
      <div class="calendar-side-bar-headline-container">
        <TText value="Project_Start" font_weight="400" />
      </div>

      <StandardDateSelector
        @input="setProjectStart({id: project_id, project_start: $event})"
        :value="getProjectStart(project_id) ? getProjectStart(project_id).substring(0, 10) : null"
        :first_day_of_week="getFirstDayOfWeek(project_id)"
        :allowed_dates="getAllowedProjectStarts"
        persistant="false"
      />

      <v-divider class="mb-1" color="grey"/>

      <!-- FREE DAYS -->
      <div class="calendar-side-bar-headline-container">
        <TText value="Free_Days" font_weight="400" />
      </div>

      <!-- CHIPS -->
      <v-hover
        v-for="freeDay in getFreeDays(project_id)"
        :key="freeDay"
      >
        <template #default="hover_chip_slot">
          <v-chip
            class="ml-1 mb-1"
            small
            :color="hover_chip_slot.hover?'red':''"
            @click="deleteFreeDay({id: project_id, date: freeDay})"
          >
            {{ freeDay }}
          </v-chip>
        </template>
      </v-hover>

      <!-- SELECT DAY FOR CHIP -->
      <StandardDateSelector
        :persistant="true"
        :multiple="true"
        :first_day_of_week="getFirstDayOfWeek(project_id)"
        :value="getFreeDays(project_id)"
        @input="setFreeDay({id: project_id, dates: $event})"
        :ok_button="true"
      >
        <template #selector="{ on }">
          <v-chip class="ml-1 mb-1" small v-on="on">
              +
          </v-chip>
        </template>
      </StandardDateSelector>

      <v-divider class="mt-1 mb-1" color="grey"/>

      <!-- COLLISIONS -->
      <div class="calendar-side-bar-headline-container">
        <TText value="Collisions" font_weight="400" />
      </div>

      <div
        v-for="collision_week in getCollisionWeeks(project_id)"
        :key="collision_week.first_day"
      >
        <!-- MONTH AND YEAR -->
        <div class="calendar-side-bar-headline-container">
          <TText
            :value="`${getMonths[getNewDate(collision_week.first_day).getMonth()]} {year}`"
            :value_props="{year: collision_week.first_day.substring(0, 4)}"
          />
        </div>
        <StandardButtonSelectorHorizontal
          class="mt-2 mb-2"
          :options="collision_week.week"
          @input="setDayCollisionWeek({id: project_id, first_day: collision_week.first_day, day: $event})"
        />

        <v-divider color="grey"/>

      </div>
    </template>

    <!-- CANCEL -->
    <template #button-left>
      <ButtonOutlined
        class="calendar-side-bar-cancel-save"
        value="Cancel"
        color="red"
        @buttonClicked="resetCalendar(project_id)"
      />
    </template>

    <!-- SAVE -->
    <template #button-right>
      <ButtonOutlined
        class="calendar-side-bar-cancel-save"
        value="Save"
        color="green"
        :is_disabled="$store.state.Ultra.projects[project_id].calendar_project_start === ''"
        :loading="loading"
        @buttonClicked="saveCalendar()"
      />
    </template>
  </SideBar>
</template>

<script>
import { ProjectMixin } from '@/mixins/Project.mixin.js';
import SideBar from '@/components/ProjectTaktPlan/SideBar.component.vue';
import StandardDateSelector from '@/components/StandardComponents/StandardDateSelector.component.vue';
import StandardButtonSelectorHorizontal from '@/components/StandardComponents/StandardButtonSelectorHorizontal.component.vue';
import TText from '@/components/Taktify/TText.component.vue';
import StandardTimePicker from '@/components/StandardComponents/StandardTimePicker.component.vue';
import CollapsableCategory from '@/components/WorkPackageWIP/CollapsableCategory.component.vue';
import TTimePicker from '@/components/Taktify/TTimePicker.component.vue';
import TIconButton from '@/components/Taktify/TIconButton.component.vue';
import TIcon from '@/components/Taktify/TIcon.component.vue';
import DropDownModular from '@/components/WorkPackageWIP/DropDownModular.component.vue';
import ButtonOutlined from '@/components/WorkPackageWIP/ButtonOutlined.component.vue';

  export default {
      components: {
          SideBar,
          StandardDateSelector,
          StandardButtonSelectorHorizontal,
          TText,
          StandardTimePicker,
          CollapsableCategory,
          TTimePicker,
          TIconButton,
          TIcon,
          DropDownModular,
          ButtonOutlined,
      },

      data: () => ({
          loading: false
      }),

      mixins: [
          ProjectMixin,
      ],

      props: [
        'project_id',
        'project'
      ],

      computed: {
        week_days_options() {
          let week_days = this.$store.state.Ultra.week_days;
          let ret = [];
          for (let i = 0; i < week_days.length; i++) {
            ret.push({ id: week_days[i]});
          }
          return ret;
        },

        takt_time_options() {
          let ret = [];
          for (let i = 0; i < 7; i++) {
            ret.push({ id: i + 1});
          }
          return ret;
        },

          // getFirstViableProjectStart() {
          //   let test_date = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)); //.toISOString().substr(0, 10)
          //   for (var i = 0; i < 7; i++) {
          //     test_date.addDays(i);
          //     if (this.getAllowedProjectStarts(test_date.toISOString().substr(0, 10))) {
          //       return test_date.toISOString().substr(0, 10);
          //     }
          //   }
          //   return test_date.toISOString().substr(0, 10);
          // }
      },

      methods: {
          getLimit(index){
            console.log(index)
            let limit = {};
            if (index == 0) {
              limit.start = this.$store.state.Ultra.projects[this.project_id].working_time_start;
            } else {
              limit.start = this.getGridSections(this.project_id)[index - 1].start + this.getGridSections(this.project_id)[index - 1].duration
            }
            if (index == this.getGridSections(this.project_id).length -1) {
              limit.duration = this.$store.state.Ultra.projects[this.project_id].working_time_start + this.$store.state.Ultra.projects[this.project_id].working_time_duration - limit.start;
            } else {
              limit.duration = this.getGridSections(this.project_id)[index + 1].start - limit.start
            }
            console.log(limit)
            return limit;
          },
          saveCalendar() {
              this.loading = true;
              this.setCalendar(this.project_id);
          },

          test(e) {
              console.log(e, 'dd')
          },

          addSection(start, index){
            let end;
            if (index == this.getGridSections(this.project_id).length -1) {
              end = this.$store.state.Ultra.projects[this.project_id].working_time_start + this.$store.state.Ultra.projects[this.project_id].working_time_duration
            } else {
              end = this.getGridSections(this.project_id)[index + 1].start;
            }
            let new_section = {
              start: start,
              duration: end - start
            }
            this.createUObject({
              url: [
                {projects: this.project_id},
                {gridsections: ''},
                {showWithEntitiesNormalized: ''},
              ],
              u_object: new_section,
              // resp_data: {
              //   gridsections: [
              //     new_section
              //   ]
              // }
            });
          },

          showAddSection(start, index){
            let end;
            if (index == -1) {
              if (this.getGridSections(this.project_id).length == 0) {
                end = this.$store.state.Ultra.projects[this.project_id].working_time_start + this.$store.state.Ultra.projects[this.project_id].working_time_duration
              } else {
                end = this.getGridSections(this.project_id)[0].start
              }
            } else if (index == this.getGridSections(this.project_id).length - 1){
              end = this.$store.state.Ultra.projects[this.project_id].working_time_start + this.$store.state.Ultra.projects[this.project_id].working_time_duration
            } else {
              end = this.getGridSections(this.project_id)[index + 1].start
            }
            if (end > start) {
              return true;
            }
            return false
          }
      },
  }
</script>

<style>
.slide-enter,
.slide-leave-to {
    transform: translateX(300px);
}

.slide-enter-active,
.slide-leave-active {
    transition: all 0.2s ease-in-out;
}
.calendar-side-bar-headline-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 28px;
}
.calendar-side-bar-top-attributes-drop-down {
  display: flex;
  grid-gap: 4px;
  align-items: center;
  padding: 4px 4px;
  border-radius: 4px;
  width: 54px;
  justify-content: flex-end;
}
.calendar-side-bar-sections-container {
  display: flex;
  flex-direction:
  column; align-items: center;
}
.calendar-side-bar-sections-element {
  display: flex;
}
.calendar-side-bar-cancel-save {
  width: 100%;
}
</style>
